import { Component, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { IonContent, IonicModule, MenuController, ModalController } from '@ionic/angular';
import { Subject, Subscription } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { AuthService } from '../auth/auth.service';
import { ThemeService } from '../_core/services/theme.service';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { LoginSignupHomeComponent } from '../auth/login-signup-home/login-signup-home.component';
import { CreateUserComponent } from '../auth/create-user/create-user.component';
import { SigninComponent } from '../auth/signin/signin.component';
import { ForgotPasswordComponent } from '../auth/forgot-password/forgot-password.component';
import { Router } from '@angular/router';

@Component({
    selector: 'app-auth-private',
    templateUrl: './auth-private.component.html',
    styleUrls: ['./auth-private.component.scss'],
    standalone: true,
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        IonicModule,
        LoginSignupHomeComponent,
        CreateUserComponent,
        SigninComponent,
        ForgotPasswordComponent
    ],
})
export class AuthPrivateComponent implements OnInit, OnDestroy {

    @ViewChild('content') content!: IonContent;
    @Input({ required: false }) isLoginModal = false;
    login = false;
    signup = false;
    verify = false;
    forgotPassword = false;
    countryCode = '';
    phone = '';
    isModal = false;
    isBottom = false;

    authStateSubscription = new Subscription();
    logo!: string;
    isDarkMode!: boolean;
    public newLoginDesign: boolean = false;

    private readonly destroy$: Subject<void> = new Subject();

    constructor(
        private authService: AuthService,
        private modalController: ModalController,
        private menuCtrl: MenuController,
        private themeService: ThemeService,
        private router: Router
    ) { }

    async ngOnInit() {
        this.handleScorekeeperAssignment();
        if (await this.authService.isAuthenticated()) {
            this.router.navigate(['/'], { replaceUrl: true });
        }
        this.authStateSubscription = this.authService.cast.subscribe((data) => {
            this.login = data.login;
            this.signup = data.signup;
            this.verify = data.verify;
            this.forgotPassword = data.forgotPassword;
            this.countryCode = data.country_code;
            this.phone = data.phone;
        });
        this.isDarkMode = this.themeService.isDarkMode;
        this.logo = this.isDarkMode ? '/assets/img/logo-60-darkmode.png' : '/assets/img/logo-60.png';

        this.themeService
            .subscribeThemeUpdate()
            .pipe(takeUntil(this.destroy$))
            .subscribe(
                (isDarkMode) => {
                    this.logo = isDarkMode ? '/assets/img/logo-60-darkmode.png' : '/assets/img/logo-60.png';
                }
            );

        // isLoginModal is set by parent component through @Input()
    }

    handleScorekeeperAssignment() {
        const params = new URLSearchParams(window.location.search);
        const as = params.get('as') === '1';
        const contextType = params.get('ct') || '';
        const contextId = params.get('cid') || '';
        const matchTournamentId = params.get('tmId') || '';
        const matchStatus = params.get('ms') || '';

        if (as && contextType && contextId) {
            localStorage.setItem('ScorekeeperContextType', contextType);
            localStorage.setItem('ScorekeeperContextId', contextId);
            localStorage.setItem('ScorekeeperMatchTournamentId', matchTournamentId);
            localStorage.setItem('ScorekeeperMatchStatus', matchStatus);
        }
    }

    ngOnDestroy() {
        this.authStateSubscription.unsubscribe();
        this.destroy$.next();
        this.destroy$.complete();
    }

    ionViewDidEnter() {
        this.menuCtrl.enable(false);
    }

    ionViewDidLeave() {
        this.menuCtrl.enable(true);
    }

    doSignin() {
        this.login = true;
        this.signup = false;
        this.verify = false;
        this.forgotPassword = false;
    }

    doSignup() {
        this.login = false;
        this.signup = true;
        this.verify = false;
    }

    doHome() {
        this.login = false;
        this.signup = false;
        this.verify = false;
        this.forgotPassword = false;
    }

    doVerify() {
        this.login = false;
        this.signup = false;
        this.verify = true;
    }

    doForgotPassword() {
        this.login = false;
        this.signup = false;
        this.forgotPassword = true;
    }

    scrollToBottom() {
        this.content.scrollToBottom(300);
        this.isBottom = true;
    }

    scrollToTop() {
        this.content.scrollToTop(300);
        this.isBottom = false;
    }

    close() {
        this.modalController.dismiss();
    }

    handleAuthAction(action: string) {
        switch (action) {
            case 'signin':
                this.doSignin();
                break;
            case 'signup':
                this.doSignup();
                break;
            case 'auth':
                this.doHome();
                break;
            case 'forgot-password':
                this.forgotPasswordPage();
                break;
        }
    }

    goBackPage() {
        this.login = false;
        this.signup = false;
        this.verify = false;
        this.forgotPassword = false;
    }

    forgotPasswordPage() {
        this.forgotPassword = true;
        this.login = false;
        this.signup = false;
    }

}
